import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable } from 'rxjs';

@Component({
  selector: 'm-upload-meta',
  exportAs: 'mUploadMeta',
  template: `
    <ng-container *ngIf="mSelfUploadTql; else defaultTql">
      <nz-upload [nzDirectory]="mDirectory" [nzBeforeUpload]="mBeforeUpload" [nzMultiple]="mMultiple" [nzAccept]="mAcceptFileType">
        <ng-container [ngTemplateOutlet]="mSelfUploadTql"></ng-container>
      </nz-upload>
    </ng-container>
    <ng-template #defaultTql>
      <nz-upload
        nzType="drag"
        class="m-upload-meta"
        [nzDirectory]="mDirectory"
        [nzBeforeUpload]="mBeforeUpload"
        [nzMultiple]="mMultiple"
        [nzAccept]="mAcceptFileType"
      >
        <p class="m-upload-meta-icon">
          <i nz-icon>
            <svg
              width="80px"
              height="72px"
              viewBox="0 0 60 54"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="m-upload-meta">
                  <stop stop-color="#D0D6E2" offset="0%"></stop>
                  <stop stop-color="#D1D5DC" offset="100%"></stop>
                </linearGradient>
              </defs>
              <g id="组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="04-业务组件/上传" transform="translate(-818.000000, -2823.000000)" fill="url(#m-upload-meta)" fill-rule="nonzero">
                  <g id="编组-33" transform="translate(41.000000, 2567.000000)">
                    <g id="编组-21" transform="translate(690.000000, 256.000000)">
                      <path
                        d="M116.5,29 L128,40.265137 L124.16486,44.0228383 L119.210346,39.1683663 L119.210346,54 L113.789654,54 L113.789654,39.163055 L108.83514,44.0228383 L105,40.265137 L116.5,29 Z M116.999662,0 C126.686759,0 134.836349,7.21640268 135.952974,16.7819531 C142.952026,18.6793197 147.579874,25.2866848 146.941259,32.4703698 C146.302643,39.6540549 140.580858,45.3522211 133.355547,46 L133.352821,40.6408293 C133.361785,31.7751829 126.223229,24.5372746 117.30634,24.3710174 C108.389451,24.2047603 100.982883,31.171472 100.657405,40.0312169 L100.646503,40.6408293 L100.646503,46 C93.420848,45.3531838 87.6981666,39.6554318 87.0588637,32.4715521 C86.4195608,25.2876723 91.0471407,18.6797122 98.0463503,16.7819531 C99.1618043,7.21579804 107.312095,-0.000766835176 116.999662,0 Z"
                        id="上传按钮"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </i>
        </p>
        <p>
          点击
          <span [ngStyle]="{ color: 'rgba(0,0,0,.45)' }">或</span>
          拖拽上传
        </p>
        <p class="m-upload-meta-hint">
          <span *ngIf="mTipText">{{ mTipText }}</span>
          支持{{ mFileTypeTip }}格式
        </p>
      </nz-upload>
    </ng-template>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MUploadMetaComponent {
  @Input() mFileTypeTip = '';
  @Input() mBeforeUpload?: (file: NzUploadFile, fileList: NzUploadFile[]) => boolean | Observable<boolean>;
  @Input() mAcceptFileType = '';
  @Input() mTipText = '';
  @Input() mMultiple = true;
  @Input() mDirectory = false;
  @Input() mSelfUploadTql: TemplateRef<void> | null = null;
}
